<template>
  <div id="titleinput" :class="displayType">
    <input type="text" :placeholder="placeholder" :value="value" :class="hasAlign" @focus="focus" @focusout="focusOut" @input="$emit('input', $event.target.value)"/>
  </div>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import ES from '@/components/js/EditorSetting.js'

export default {
  props: {
    value: { type: String, default: '' },
    isReFocus: { type: Boolean },
    placeholder: {type: String, default: '제목을 입력해 주세요'},
    displayType: {type: String, default: 'title'},
    type: { type: String },
    align: { type: String }
  },
  data: function () {
    return {
      hasAlign: 'text_' + this.align
    }
  },
  name: 'TitleInput',
  methods: {
    changeTool (cmd, value) {
      this.hasAlign = 'text_' + value
    },
    focus (e) {
      if (this.type !== ES.TYPE_TITLE) {
        console.log(this.type)
        this.$emit('update:type', ES.TYPE_TITLE)
        this.$emit('update:align', document.querySelector('#titleinput input').className)
        console.log(this.type)
      }
    },
    focusOut (e) {
      console.log('title focus out')
      if (this.isReFocus) {
        document.querySelector('#titleinput input').focus()
        this.$emit('update:isReFocus', false)
      } else {
        if (this.type === ES.TYPE_TITLE) {
          this.$emit('update:type', '')
        }
      }
      this.$emit('update:value', document.querySelector('#titleinput input').value)
    }
  },
  computed: {
  },
  components: {
    'UInput': UInput
  }
}
</script>

<style scoped>
.title {
  display: flex;
  height: 80px;
  align-items: center;
}
input:focus {
  outline: none;
}
input::placeholder {
  color: var(--text-guide);
}
.title input {
  flex: 1;
  border: 0px;
  padding: 0px 0px 0px 5px;
  height: 100%;
  font-size: 2em;
}
.title .text_left {
  text-align: left;
}
.title .text_center {
  text-align: center;
}
.title .text_right {
  text-align: right;
}
.title .text_justify {
  text-align: justify;
}
.subtitle input {
  flex: 1;
  border: 0px;
  padding: 0px 0px 0px 5px;
  height: 100%;
  font-size: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/TitleInput.vue